import React, { createContext, useContext, ReactNode } from 'react';
import { ProcessStepConfiguration } from './process-types';

interface ProcessContextType<FORM = any> {
  steps: ProcessStepConfiguration<FORM>[];
}

const ProcessContext = createContext<ProcessContextType | undefined>(undefined);

export function ProcessProvider<FORM>({
  children,
  steps,
}: {
  children: ReactNode;
  steps: ProcessStepConfiguration<FORM>[];
}) {
  return (
    <ProcessContext.Provider value={{ steps }}>
      {children}
    </ProcessContext.Provider>
  );
}

export const useProcessContext = (): ProcessContextType => {
  const context = useContext(ProcessContext);
  if (!context) {
    throw new Error('useProcessContext must be used within a ProcessProvider');
  }
  return context;
};
